// ignore-string-externalization
import React from 'react';
import { ContentGrid } from '../../ContentGrid';
import { jsx as _jsx } from "react/jsx-runtime";
export var EditorialGridModule = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
      headline = _ref.headline,
      subtext = _ref.subtext,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      ctaText = _ref.ctaText,
      ctaLink = _ref.ctaLink;
  return /*#__PURE__*/_jsx(ContentGrid, {
    ref: ref,
    trackCategory: "module-editorialGrid",
    "data-testid": "editorial-grid-module-".concat(id),
    headline: headline,
    subtext: subtext,
    items: items,
    featuredItems: 2,
    ctaText: ctaText,
    ctaLink: ctaLink
  });
});